import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';

import { TranslateModule } from '@ngx-translate/core';

import { CheckableColumnModule } from '@shared/components/table/checkable-column/checkable-column.module';
import { SharedModule } from '@shared/shared.module';

import { VipDiscountsOriginalPricesModalComponent } from './components/vip-discounts-original-prices-modal/vip-discounts-original-prices-modal.component';

@NgModule({
  declarations: [VipDiscountsOriginalPricesModalComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatTableModule,
    TranslateModule,
    CheckableColumnModule,
  ],
  exports: [VipDiscountsOriginalPricesModalComponent],
})
export class VipDiscountsModule {}
